import { render, staticRenderFns } from "./correspondingPeriod.vue?vue&type=template&id=6d076a4c&scoped=true&"
import script from "./correspondingPeriod.vue?vue&type=script&lang=ts&"
export * from "./correspondingPeriod.vue?vue&type=script&lang=ts&"
import style0 from "./correspondingPeriod.vue?vue&type=style&index=0&id=6d076a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d076a4c",
  null
  
)

export default component.exports